"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useRealTimeWebSocket: ()=>useRealTimeWebSocket
});
const external_react_namespaceObject = require("react");
const WebSocketManager_js_namespaceObject = require("../utils/WebSocketManager.js");
function useRealTimeWebSocket({ url, locale = 'en-us', realtimeContext, onMessage, analytics, pennysid, requestFrom, isCustomVoice = false }) {
    const [isConnected, setIsConnected] = (0, external_react_namespaceObject.useState)(false);
    const wsManager = WebSocketManager_js_namespaceObject.WebSocketManager.getInstance();
    const connectionKey = `${url}-${locale}`;
    const getWebSocketUrl = (0, external_react_namespaceObject.useCallback)((baseUrl)=>{
        if ('development' === process.env.NODE_ENV) switch(window.location.hostname){
            case 'localhost':
                return 'ws://0.0.0.0:8080';
            case 'local.priceline.com':
                return 'wss://local.priceline.com';
            default:
                return baseUrl;
        }
        return baseUrl.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:');
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const wsUrl = getWebSocketUrl(url);
        const fullUrl = `${wsUrl}/genai-svc/genai/realtime/chat?locale=${locale}&pennysid=${pennysid}&requestFrom=${requestFrom}&isCustomVoice=${isCustomVoice}`;
        const ws = wsManager.createConnection(connectionKey, fullUrl);
        const handleOpen = ()=>{
            setIsConnected(true);
            const pingInterval = setInterval(()=>{
                if (ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify({
                    type: 'realtime_ping'
                }));
            }, 30000);
            return pingInterval;
        };
        const handleClose = (event)=>{
            setIsConnected(false);
            if (1005 !== event.code) analytics.logError({
                loggedFrom: 'useRealTimeWebSocket.onclose',
                message: `WebSocket closed - Code: ${event.code}, Reason: ${event.reason}`,
                error: event
            });
        };
        const handleError = (error)=>{
            analytics.logError({
                loggedFrom: 'useRealTimeWebSocket.onerror',
                message: 'WebSocket encountered an error',
                error
            });
            setIsConnected(false);
        };
        let pingInterval = null;
        if (ws.readyState === WebSocket.CONNECTING) {
            ws.onopen = ()=>{
                pingInterval = handleOpen();
            };
            ws.onclose = handleClose;
            ws.onerror = handleError;
        } else if (ws.readyState === WebSocket.OPEN) pingInterval = handleOpen();
        wsManager.addMessageListener(connectionKey, onMessage);
        return ()=>{
            wsManager.removeMessageListener(connectionKey, onMessage);
            if (pingInterval) clearInterval(pingInterval);
            wsManager.closeConnection(connectionKey);
        };
    }, [
        url,
        locale,
        realtimeContext,
        onMessage,
        analytics,
        getWebSocketUrl,
        connectionKey
    ]);
    const sendMessage = (0, external_react_namespaceObject.useCallback)((message)=>{
        const ws = wsManager.getConnection(connectionKey);
        if (!ws || ws.readyState !== WebSocket.OPEN) return void console.warn('WebSocket is not connected');
        const messageStr = 'string' == typeof message ? message : JSON.stringify(message);
        ws.send(messageStr);
    }, [
        connectionKey
    ]);
    return {
        isConnected,
        sendMessage
    };
}
exports.useRealTimeWebSocket = __webpack_exports__.useRealTimeWebSocket;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useRealTimeWebSocket"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
